import React, { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDatePicker from "../../common/ReactDatePicker";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../../utility";
import axios from "axios";
import Loader from "../../common/Loader";
import { useForm } from "react-hook-form";
import Dropdown from "../../common/Dropdown";
import TimeInput from "../../common/TimeInput";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const currentTimePlus5mint = new Date().toLocaleTimeString('en-US', { hour12: false });

function formate1(dt) {
    const formattedDate = new Date(dt).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
    console.log(formattedDate);
    return formattedDate;
}

function currentDateFunc() {
    const currentDate = new Date();

    const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const monthsOfYear = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dayOfWeek = daysOfWeek[currentDate.getDay()];
    const month = monthsOfYear[currentDate.getMonth()];
    const date = currentDate.getDate();
    const year = currentDate.getFullYear();
    const time = '00:00:00';
    const timezone = currentDate.toString().match(/\((.+)\)/)[1]; // Extract timezone from toString()

    const formattedDate = `${dayOfWeek} ${month} ${date} ${year} ${time} GMT${currentDate.getTimezoneOffset() > 0 ? '-' : '+'}${Math.abs(currentDate.getTimezoneOffset() / 60).toString().padStart(2, '0')}${currentDate.getTimezoneOffset() % 60 !== 0 ? currentDate.getTimezoneOffset() % 60 : ''}00 (${timezone})`;
    // console.log("date : ", date);
    console.log(formattedDate);
    return formattedDate;
}

const StaffDetail = () => {
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);

    const [startDate, setStartDate] = useState();

    const [loading, setLoading] = useState(true);

    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const navigate = useNavigate();

    const { id } = useParams();

    const [allocation_type, setAllocationType] = useState(null);
    const [day, setDay] = useState(null);
    const [day2, setDay2] = useState(null);
    const [day3, setDay3] = useState(null);

    const [time, setTime] = useState("00:00");
    const [time2, setTime2] = useState("00:00");
    const [time3, setTime3] = useState("00:00");

    const [funding_amount, setFundingAmount] = useState(null);



    // Register the date picker with React Hook Form
    const registerDatePicker = register('allocation_day', { required: true });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleClose2 = () => {
        setTime(null);
        setTime2(null);
        setTime3(null);
        setDay(null);
        setDay2(null);
        setDay3(null);
        setFundingAmount(null);
        setAllocationType(null);
        setStartDate(null);
        setShow2(false)
    };
    const handleShow2 = () => setShow2(true);


    const [flag, setFlag] = useState(2);
    const [staffDetail, setStaffDetail] = useState(null);
    const [error, setError] = useState(null);


    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/staff/viewStaff/${id}`, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
            console.log("staff Detail res : ", res);
            setStaffDetail(res?.data?.staff);
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log("staff detail error : ", err);
        })
    }, [flag])


    const onSendAllocate = () => {
        let flag2 = 0;
        const obj1 = { staff_id: id, allocation_type, funding_amount, allocation_time: time, allocation_day: day };
        const obj2 = { staff_id: id, allocation_type, funding_amount, allocation_time: time2, allocation_day: day2 };
        const obj3 = { staff_id: id, allocation_type, funding_amount, allocation_time: time3, allocation_date: formate1(startDate) };

        console.log("data : ", obj3);

        if (allocation_type === "week") {
            if (funding_amount !== null && time !== null && day !== null) {
                flag2 = 1;
            }
        }
        if (allocation_type === "month") {
            if (funding_amount !== null && time2 !== null && day2 !== null) {
                flag2 = 2;
            }
        }
        if (allocation_type === "manual") {
            const currentDate = new Date();
            const currentTime = currentDate.getTime();
            const selectedDate = new Date(startDate);
            // console.log("current time : ", currentTime);
            // console.log("current date : ", currentDate);
            // console.log("selected date : ", selectedDate);
            // console.log("start date : ", startDate);
            console.log(formate1(selectedDate), formate1(currentDateFunc()));
            if (formate1(selectedDate) >= formate1(currentDateFunc())) {
                console.log("condition one")
                if (formate1(selectedDate) === formate1(currentDateFunc())) {
                    console.log("condition two")
                    if (time3) {
                        const timeString = "19:31";
                        const [hours, minutes] = time3?.split(':');
                        const date = new Date();
                        date.setHours(hours);
                        date.setMinutes(minutes);
                        const milliseconds = date.getTime();
                        const currentTimePlus5 = currentTime + (5 * 60 * 1000);
                        console.log("current time : ", currentTime);
                        console.log("current time : ", currentTimePlus5);
                        console.log("milliseconds time : ", milliseconds);
                        if (currentTimePlus5 < milliseconds) {
                            flag2 = 3;
                            console.log("Time true ")
                        } else {
                            console.log("Time false ")
                            toast.warn("If you select current date then time should be 5 mint plus in current time ");
                        }

                    } else {
                        // toast.warn("If you select current date then time should be 5 mint plus in current time ");
                        // console.log("Tiem three null")
                    }

                } else {
                    if (funding_amount !== null && time3 !== null && startDate !== null) {
                        flag2 = 3;
                    }
                }
            } else {
                toast.warn("Select should be current date or greater");
            }
        }


        if (flag2 > 0) {
            const token = localStorage.getItem("user_token");
            // console.log("token : ", token);
            console.log("condition true : ", obj3);
            console.log("start: date : ", startDate);
            console.log("flag : ", flag2);
            axios.post(`${API_URL}/user/staff/${id}/allocate-fund`, flag2 === 1 ? obj1 : flag2 === 2 ? obj2 : obj3, { headers: { 'Authorization': `Bearer ${token}` } }).then((res) => {
                console.log("Allocate res : ", res);
                setFlag(flag + 1);
                toast.success("Funds allocated successfully");
                handleClose2();
                setLoading(false);
            }).catch((err) => {
                toast.error(err?.response?.data?.errors?.allocation_date ? err?.response?.data?.errors?.allocation_date[0] : err?.response?.data?.errors?.allocation_time ? err?.response?.data?.errors?.allocation_time[0] : err?.response?.data?.errors?.allocation_day ? err?.response?.data?.errors?.allocation_day[0] : err?.response?.data?.errors?.allocation_type ? err?.response?.data?.errors?.allocation_type[0] : err?.response?.data?.errors?.funding_amount ? err?.response?.data?.errors?.funding_amount[0] : "Server Error")
                setLoading(false);
                console.log("Allocate error : ", err);
            })
        } else {
            toast.warn("Enter valid value in required fields ");
        }


    }

    useEffect(() => {
        if (startDate) {
            setAllocationType("manual");
        }
    }, [startDate])

    console.log("weekTime : ", time);
    console.log("monthTime : ", time2);
    console.log("manualTime : ", time3);
    console.log("allocation type : ", allocation_type);

    const displayRegNo = staffDetail?.registration_no ? staffDetail?.registration_no.split(/[,/]/)[0] : 'Plate Number Not found'; //regex for plate number
    const dayOptions = Array.from({ length: 31 }, (_, i) => {
        const day = i + 1;
        const suffix = (day) => {
            if (day > 3 && day < 21) return "th";
            switch (day % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };
        return { value: `${day}`, label: `${day}${suffix(day)}` };
    });

    const dayOfWeekOptions = [
        { value: "Monday", label: "Monday" },
        { value: "Tuesday", label: "Tuesday" },
        { value: "Wednesday", label: "Wednesday" },
        { value: "Thursday", label: "Thursday" },
        { value: "Friday", label: "Friday" },
        { value: "Saturday", label: "Saturday" },
        { value: "Sunday", label: "Sunday" },
    ];

    const [weekHour, setWeekHour] = useState("00");
    const [weekMinute, setWeekMinute] = useState("00");
    const [monthHour, setMonthHour] = useState("00");
    const [monthMinute, setMonthMinute] = useState("00");
    const [manualHour, setManualHour] = useState("00");
    const [manualMinute, setManualMinute] = useState("00");

    return (
        <div className="staff-detail-page">
            <ToastContainer />
            <h1 className="staffRegNumber">{displayRegNo}</h1>
            {/* {staffDetail?.staff_account} */}
            <h6 className="breadCrumbs mt-4 pb-3">
                <span className="pointer" onClick={() => navigate('/vcards')}>VCards</span>
                <span className="greater-than"> &#62; </span>
                <span className="viewVCardText">View VCard</span>
            </h6>
            <h3 className="staffdetail-sub-heading mt-4 mb-0">VCard Details</h3>
            {loading ? (<Loader />) : (
                <>
                    <div className="d-flex pt-3">
                        <div className="div1 d-flex flex-column">
                            {/* <p className="mb-0">Staff account</p> */}
                            <p className="displayBlockText">Status</p>
                            <p className="displayBlockText">Wallet</p>
                            {/* <p className="displayBlockText">Name - Surname</p> */}
                            {/* <p className="displayBlockText">Address</p> */}
                            {/* <p className="displayBlockText">Email</p> */}
                            {/* <p className="displayBlockText">Phone</p> */}
                            <p className="displayBlockText">VCard</p>
                            <p className="displayBlockText">VIN</p>
                            <p className="displayBlockText">Registration Number</p>
                            <p className="displayBlockText">RFID No.</p>
                            <p className="displayBlockText">Volta</p>
                            <p className="displayBlockText">Model</p>
                            <p className="displayBlockText">Color Description</p>
                            <p className="displayBlockText">Total Topup</p>
                            {/* <p className="displayBlockText">V-Card status</p> */}
                            <p className="displayBlockText">Allocation Details</p>
                        </div>
                        <div className="div2 d-flex flex-column">
                            {/* <p className="displayBlockText">{staffDetail?.staff_account}</p> */}
                            {staffDetail?.staff_status === "1" ? (
                                <p className="displayBlockText color-42c78f">Enable</p>
                            ) : (
                                <p className="displayBlockText text-danger">Disable</p>
                            )}
                            <p className="displayBlockText">{staffDetail?.staff_wallet ? Number(staffDetail?.staff_wallet).toFixed(2) : 0}</p>
                            {/* <p className="displayBlockText">{staffDetail?.staff_name} {staffDetail?.staff_surename}</p> */}
                            {/* <p className="displayBlockText">{staffDetail?.staff_address}</p> */}
                            {/* <p className="displayBlockText">{staffDetail?.staff_email}</p> */}
                            {/* <p className="displayBlockText">{staffDetail?.staff_phone_number}</p> */}
                            <p className="displayBlockText">{staffDetail?.staff_vcard ? staffDetail?.staff_vcard : 0}</p>
                            <p className="displayBlockText">{staffDetail?.vin_id}</p>
                            <p className="displayBlockText">{staffDetail?.registration_no}</p>
                            <p className="displayBlockText">{staffDetail?.rfid_no}</p>
                            <p className="displayBlockText">{staffDetail?.volta}</p>
                            <p className="displayBlockText">{staffDetail?.model}</p>
                            <p className="displayBlockText">{staffDetail?.color_desc}</p>
                            <p className="displayBlockText">{Number(staffDetail?.fund_transfer_sum).toFixed(0)}</p>

                            {staffDetail?.fund_detial ? (
                                staffDetail?.fund_detial?.allocation_type === "week" ? (
                                    <p className="displayBlockText">{staffDetail?.fund_detial?.funding_amount} - Every week on {staffDetail?.fund_detial?.allocation_day} at {staffDetail?.fund_detial?.allocation_time} </p>
                                ) : staffDetail?.fund_detial?.allocation_type === "month" ? (
                                    <p className="displayBlockText">{staffDetail?.fund_detial?.funding_amount} - Every month on {staffDetail?.fund_detial?.allocation_day}{staffDetail?.fund_detial?.allocation_day === "1" ? 'st' : staffDetail?.fund_detial?.allocation_day === "2" ? 'nd' : 'th'} at {staffDetail?.fund_detial?.allocation_time}</p>
                                ) : (
                                    <p className="displayBlockText">{staffDetail?.fund_detial?.funding_amount} - Manual  {formate1(staffDetail?.fund_detial?.allocation_date)} at {staffDetail?.fund_detial?.allocation_time} (Once Only)</p>
                                )

                            ) : (
                                <p className="displayBlockText">Not Allocated</p>
                            )}

                            {/* <p className="displayBlockText mt-2"><input defaultValue={staffDetail?.registration_no} type="text" className="form-control" /></p> */}
                            {/* <p className="displayBlockText">
                                <span className="color-42c78f">Verify</span>
                                <button onClick={handleShow} className="btn-2 ms-4">Re-verify</button>
                            </p> */}
                        </div>
                    </div>

                    <div className="mt-4">
                        <button onClick={handleShow2} className="pointerButton">Edit Allocation</button>
                    </div>

                    {/* <h3 className="staffdetail-sub-heading mt-4 mb-0">Allocation Details</h3>
                    <div className="d-flex pt-3">
                        <div className="divAllocateLeft d-flex flex-column">
                            <p className="displayBlockText">Allocation Details</p>
                            <p className="displayBlockText mt-2">
                                <button onClick={handleShow2} className="pointerButton" style={{height:"85%"}}>Edit Allocate</button>
                            </p>
                            <p className="displayBlockText pt-3">Top Up Report</p>
                            <p className="displayBlockText pt-3 mt-2">Usage Report</p>
                        </div>
                            <div className="divAllocateRight d-flex flex-column">
                                {staffDetail?.fund_detial ? (
                                    staffDetail?.fund_detial?.allocation_type === "week" ? (
                                        <p className="displayBlockText">{staffDetail?.fund_detial?.funding_amount} - Every week on {staffDetail?.fund_detial?.allocation_day} at {staffDetail?.fund_detial?.allocation_time} </p>
                                    ): staffDetail?.fund_detial?.allocation_type === "month" ? (
                                        <p className="displayBlockText">{staffDetail?.fund_detial?.funding_amount} - Every month on {staffDetail?.fund_detial?.allocation_day}{staffDetail?.fund_detial?.allocation_day === "1" ? 'st': staffDetail?.fund_detial?.allocation_day === "2" ? 'nd' : 'th'} at {staffDetail?.fund_detial?.allocation_time}</p>
                                    ) :(
                                        <p className="displayBlockText">{staffDetail?.fund_detial?.funding_amount} - Manual  {formate1(staffDetail?.fund_detial?.allocation_date)} at {staffDetail?.fund_detial?.allocation_time} (Once Only)</p>
                                    )

                                ) : (
                                    <p className="displayBlockText">Not Allocated</p>
                                )}
                                <p className="mb-0 pt-3">
                                    <button className="btn-2 ms-4" onClick={() => navigate(`/staff-report/1`)}>View</button>
                                </p>
                                <p className="mb-0 pt-4 mt-2">
                                    <button className="btn-2 ms-4" onClick={() => navigate(`/staff-report/1`)}>View</button>
                                </p>
                            </div>
                    </div>
                    <div className="mb-5 pt-4">
                        <button className="btn-3 mt-4">Edit</button>
                    </div> */}
                </>
            )}

            {/* model one  */}

            <Modal show={show} onHide={handleClose} size="lg">
                <div className="verify-email-div">
                    <h1>Verify V-card</h1>
                    <p className="pt-4 mt-4 mb-4 pb-4">Please confirm verification. V card in <b>angleria_2539@gmail.com</b> within 24 hours</p>

                    <div className="text-center">
                        <button className="btn-3 btn-1 me-2" onClick={handleClose}>Send</button>
                        <button className="btn-2 ms-2" onClick={handleClose}>Cancel</button>
                    </div>

                </div>
            </Modal>

            {/* model two  */}

            <Modal show={show2} onHide={handleClose2} dialogClassName="modal-width-900px">
                <div className="verify-email-div">
                    {/* <form> */}
                    <h1>Edit allocate fund</h1>
                    
                    <div className="balanceBar d-flex justify-content-between align-items-center py-3">
                        <div><h3>Current Balance <span className="ms-4"> {(Number(staffDetail?.staff_wallet)).toFixed(2)}</span></h3></div>
                        <div><h3>Max Balance <span className="ms-4">{(Number(staffDetail?.max_fund)).toFixed(2)}</span></h3></div>
                    </div>

                    <div className="p-3 w-100">
                        
                        <h3 className="mt-2 mb-0">Add Fund</h3>
                        <div className="mt-3 d-flex align-items-center">
                            <input
                                type="number"
                                onChange={(e) => {
                                    if (Number(e.target.value) > Number(staffDetail?.max_fund)) {
                                        setError(true);
                                    } else {
                                        setError(false);
                                    }
                                    setFundingAmount(e.target.value)
                                }}
                                className="searchBox d-inline-block"
                                style={{ width: 'calc(100% - 52px)', height: '44px'}}
                                placeholder="Enter amount"
                            /> <label className="ms-3 fw-bold">THB</label>
                            {error && <p className="text-danger">Maximum fund can be {staffDetail?.max_fund}</p>}
                        </div>

                        <h3 className="mt-4">Automatic</h3>
                        <div className="timePick mt-4 d-flex align-items-center">
                            <input className="p-2" value="week" checked={allocation_type === "week" ? true : false} onChange={(e) => setAllocationType(e.target.value)} type="radio" name="type" />
                            <label className="mx-2">Every</label>
                            <div style={{ width: '200px' }}>
                                <Dropdown
                                    options={dayOfWeekOptions}
                                    value={dayOfWeekOptions.find(option => option.value === day)}
                                    onChange={(option) => {
                                        setDay(option.value);
                                        setAllocationType("week");
                                    }}
                                    placeholder="Day"
                                />
                            </div>
                            <label className="mx-2">at</label>
                            <TimeInput
                                selectedHour={weekHour}
                                selectedMinute={weekMinute}
                                onChangeHour={(hour) => {
                                    const newWeekTime = hour.value + ":" + weekMinute;
                                    setWeekHour(hour.value);
                                    setTime(newWeekTime);
                                    setAllocationType("week");
                                }}
                                onChangeMinute={(minute) => {
                                    const newWeekTime = weekHour + ":" + minute.value;
                                    setWeekMinute(minute.value);
                                    setTime(newWeekTime);
                                    setAllocationType("week");
                                }}
                            />
                            <label className="ms-2">in week.</label>
                        </div>

                        <div className="d-flex justify-content-between mt-4">
                            <div className="w-25 bdr-t"></div>
                            <div className="w-15 text-center" style={{ width: '15%' }}><label>Or</label></div>
                            <div className="w-25 bdr-t"></div>
                        </div>

                        <div className="timePick mt-4 d-flex align-items-center">
                            <input className="p-2" type="radio" checked={allocation_type === "month" && true} value="month" onChange={(e) => setAllocationType(e.target.value)} name="type" />
                            <label className="mx-2">Every</label>
                            <div style={{ width: '200px' }}>
                                <Dropdown
                                    options={dayOptions}
                                    value={dayOptions.find(option => option.value === day2)}
                                    onChange={(option) => {
                                        setDay2(option.value);
                                        setAllocationType("month");
                                    }}
                                    placeholder="Day"
                                />
                            </div>
                            <label className="mx-2">at</label>
                             <TimeInput
                                selectedHour={monthHour}
                                selectedMinute={monthMinute}
                                onChangeHour={(hour) => {
                                     const newMonthTime = hour.value + ":" + monthMinute;
                                    setMonthHour(hour.value);
                                    setTime2(newMonthTime);
                                    setAllocationType("month");
                                }}
                                onChangeMinute={(minute) => {
                                    const newMonthTime = monthHour + ":" + minute.value;
                                    setMonthMinute(minute.value);
                                    setTime2(newMonthTime);
                                    setAllocationType("month");
                                }}
                            />
                            <label className="ms-2">in month.</label>
                        </div>

                        <h3 className="mt-4">Manual</h3>

                        <div className="timePick mt-4 d-flex align-items-center">
                            <input className="p-2" type="radio" value="manual" checked={allocation_type === "manual" && true} onChange={(e) => setAllocationType(e.target.value)} name="type" />
                            <div className="d-inline-block ms-5" style={{ width: '220px'}}>
                                <ReactDatePicker 
                                    defaultValue={startDate} 
                                    startDate={startDate} 
                                    setStartDate={setStartDate} />
                            </div>
                            <label className="mx-2">at</label>
                            <TimeInput
                                selectedHour={manualHour}
                                selectedMinute={manualMinute}
                                onChangeHour={(hour) => {
                                    const newManualTime = hour.value + ":" + manualMinute;
                                    setManualHour(hour.value);
                                    setTime3(newManualTime);
                                    setAllocationType("manual");
                                }}
                                onChangeMinute={(minute) => {
                                    const newManualTime = manualHour + ":" + minute.value;
                                    setManualMinute(minute.value);
                                    setTime3(newManualTime);
                                    setAllocationType("manual");
                                }}
                            />                   
                            <label className="ms-2">Once Only</label>
                        </div>
                    </div>
                    <div className="d-flex mt-5">
                        <button className="pointerButton px-5 w-50" disabled={error} onClick={onSendAllocate}>Send</button>
                        <button className="secondaryPointerButton ms-4 px-5 w-50" type="button" onClick={handleClose2}>Cancel</button>
                    </div>
                    {/* </form> */}
                </div>
            </Modal>

        </div>
    )
}

export default StaffDetail;